import React from 'react';
import {View, ScrollView, StyleSheet} from 'react-native';
import {Text, Card, Appbar, Divider} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useNavigation} from '@react-navigation/native';
import {useAuthStore} from '../../store/useAuthStore';
import {colors, spacing} from '../../theme';

const ProfileScreen = () => {
  const {t} = useTranslation();
  const navigation = useNavigation();
  const {user} = useAuthStore();

  return (
    <View style={styles.container}>
      <Appbar.Header style={styles.appbar} dark>
        <Appbar.BackAction onPress={() => navigation.goBack()} color={colors.white} />
        <Appbar.Content title={t('settings.profile')} titleStyle={styles.appbarTitle} />
      </Appbar.Header>

      <ScrollView>
        <Card style={styles.card}>
          <Card.Content>
            <View style={styles.avatarContainer}>
              <View style={styles.avatar}>
                <Text style={styles.avatarText}>
                  {(user?.fullName || '?').charAt(0).toUpperCase()}
                </Text>
              </View>
              <Text variant="headlineSmall" style={styles.name}>{user?.fullName}</Text>
            </View>

            <Divider style={styles.divider} />

            <InfoRow label={t('auth.email')} value={user?.email || '-'} />
            <InfoRow label={t('auth.phone')} value={user?.phone || '-'} />
            {user?.tenantName && <InfoRow label={t('auth.shopName')} value={user.tenantName} />}
          </Card.Content>
        </Card>
      </ScrollView>
    </View>
  );
};

const InfoRow = ({label, value}) => (
  <View style={styles.infoRow}>
    <Text variant="bodySmall" style={styles.infoLabel}>{label}</Text>
    <Text variant="bodyMedium" style={styles.infoValue}>{value}</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: colors.background},
  appbar: {backgroundColor: colors.primary},
  appbarTitle: {color: colors.white},
  card: {margin: spacing.md, backgroundColor: colors.surface, borderRadius: 12},
  avatarContainer: {alignItems: 'center', paddingVertical: spacing.md},
  avatar: {
    width: 80, height: 80, borderRadius: 40,
    backgroundColor: colors.primary, justifyContent: 'center', alignItems: 'center',
    marginBottom: spacing.sm,
  },
  avatarText: {color: colors.white, fontSize: 36, fontWeight: 'bold'},
  name: {fontWeight: 'bold', color: colors.text},
  divider: {marginVertical: spacing.md},
  infoRow: {marginBottom: spacing.md},
  infoLabel: {color: colors.textSecondary, marginBottom: 2},
  infoValue: {color: colors.text},
});

export default ProfileScreen;
